import { camelCase, isObject, mapKeys, mapValues } from 'lodash-es';

type AsString<T> = T extends string ? T : never;

type SnakeCaseToCamelCase<S extends string> = S extends `${infer P1}_${infer P2}${infer P3}`
    ? `${P1}${Capitalize<P2>}${SnakeCaseToCamelCase<P3>}`
    : S;

type SnakeToCamel<T> = {
    [K in keyof T as string extends K ? K : SnakeCaseToCamelCase<AsString<K>>]: T[K] extends Array<infer U>
        ? Array<U extends object ? SnakeToCamel<U> : U>
        : T[K] extends object
          ? SnakeToCamel<T[K]>
          : T[K];
};

type SnakeToCamelDeep<T> = T extends object ? SnakeToCamel<T> : T;

const snakeToCamelCaseDeep = <T>(obj: T): SnakeToCamelDeep<T> => {
    if (Array.isArray(obj)) {
        return obj.map(snakeToCamelCaseDeep) as SnakeToCamelDeep<T>;
    }
    if (!isObject(obj)) return obj as SnakeToCamelDeep<T>;
    const camelizedObject = mapKeys(obj, (_, key) => camelCase(key));
    return mapValues(camelizedObject, snakeToCamelCaseDeep) as SnakeToCamelDeep<T>;
};

export type { SnakeToCamelDeep };
export { snakeToCamelCaseDeep };
